import React, { useState } from "react";
import { LiabilityCheckbox } from "@/components/LiabilityConsent";
import { Gift, Clock, Loader2, Image as ImageIcon, Video } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const PaymentSoonDialog = ({ promoCode, onActivate, onClose, busy, isTrial }) => {
  const [agreed, setAgreed] = useState(false);
  const [code, setCode] = useState(promoCode || "");
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="bg-popover border-border max-w-md" dir="rtl" data-testid="payment-soon-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Clock className="w-5 h-5 text-accent" /> الدفع الإلكتروني سيتوفر قريباً</DialogTitle>
          <DialogDescription>نعمل على تفعيل بوابة الدفع الآمنة، وسنُشعرك فور إطلاقها.</DialogDescription>
        </DialogHeader>
        <div className="rounded-2xl border border-accent/40 bg-accent/5 p-4 space-y-3">
          <div className="flex items-center gap-2 font-bold"><Gift className="w-5 h-5 text-accent" /> جرّب رواج الذكية مجاناً لمدة شهر</div>
          <div className="flex gap-4 text-sm">
            <span className="flex items-center gap-1"><ImageIcon className="w-4 h-4 text-primary" /> صورتان</span>
            <span className="flex items-center gap-1"><Video className="w-4 h-4 text-primary" /> فيديو واحد</span>
            <span className="text-muted-foreground">مسار «محتوى متنوع»</span>
          </div>
          {isTrial ? (
            <p className="text-sm text-primary font-semibold" data-testid="trial-already-active">التجربة المجانية مفعّلة على حسابك بالفعل.</p>
          ) : (
            <>
              <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} dir="ltr"
                placeholder="كود التجربة" className="bg-secondary border-border text-center font-bold tracking-widest" data-testid="trial-coupon-input" />
              <LiabilityCheckbox checked={agreed} onChange={setAgreed} />
              <Button onClick={() => onActivate(code.trim())} disabled={busy || !code.trim() || !agreed} className="w-full font-bold gap-2" data-testid="activate-trial-btn">
                {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Gift className="w-4 h-4" />} فعّل التجربة المجانية
              </Button>
            </>
          )}
        </div>
        <p className="text-[11px] text-muted-foreground text-center">الكوبون يُستخدم مرة واحدة لكل حساب، والتجربة تنتهي تلقائياً بعد 30 يوماً.</p>
        <p className="text-xs text-muted-foreground text-center">اقتراحاتك وتوصياتك تهمّنا: <a href="mailto:Support@Rawajsmart.com" className="text-primary hover:underline" dir="ltr" data-testid="soon-feedback-email">Support@Rawajsmart.com</a></p>
      </DialogContent>
    </Dialog>
  );
};
